/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { AskUserQuestionScaleRange } from "./AskUserQuestionScaleRange";

export interface AskUserQuestionScale {
  question_type: "scale";
  question: string;
  scale_range: AskUserQuestionScaleRange;
}
